<template>
  <div
    class="award-winner-section"
    :class="{ 'award-winner-section--favorite': winnerData.favorite }"
  >
    <div class="award-winner-section__data">
      <figure class="award-winner-section__badge">
        <img :src="badgeImage" alt="" />
      </figure>

      <p>
        <span class="award-winner-section__name" v-text="winnerData.name" />

        <span
          v-if="category === 'PIT_CREW' && winnerData.time"
          class="award-winner-section__time"
          v-text="winnerData.time"
        />

        <span v-if="winnerData.favorite" class="award-winner-section__favorite">
          <i><img :src="require('@/assets/img/AwardPage/icon_favorite.svg')" alt="" /></i>
          {{ favoriteText }}
        </span>
      </p>
    </div>

    <figure class="award-winner-section__image">
      <img :src="winnerData.image" alt="" />
    </figure>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import useAward from '@/components/LinkPage/hooks/useAward'
import { AwardRankingData } from '@/components/LinkPage/AwardPane.vue'
import { AwardRankingCategoryType } from '@/store/stores/collectionModule/documents/award/AwardDataDocument'

/**
 * SFgo Award ランキング1位 セクション
 */
export default defineComponent({
  name: 'AwardWinnerSection',
  props: {
    category: {
      type: String as PropType<AwardRankingCategoryType>,
      required: true,
    },
    badgeImage: {
      type: String,
      required: true,
    },
    winnerData: {
      type: Object as PropType<AwardRankingData>,
      required: true,
    },
  },
  setup(props) {
    const { getFavoriteText } = useAward()

    /**
     * お気に入りテキストを取得
     */
    const favoriteText = computed(() => getFavoriteText(props.category))

    return {
      favoriteText,
    }
  },
})
</script>

<style lang="scss" scoped>
.award-winner-section {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 12px;
  padding: 8px 14px 20px;
  background: rgba(255, 255, 255, 0.3);

  &--favorite {
    color: $green-light;
  }

  &__image {
    display: block;
    width: min(34.67vw, 130px);
  }

  &__data {
    width: calc(100% - min(34.67vw, 130px) - 12px);
    text-align: center;
    font-family: $fontSignup;
    font-size: min(4.267vw, 16px);
    font-weight: 500;
    line-height: 1.5;

    span {
      display: block;
      width: 100%;
      text-align: center;
    }
  }

  &__badge {
    width: min(26.67vw, 100px);
    margin: 0 auto 8px;
  }

  &__time {
    margin-top: 4px;
    font-family: $fontFamilyDefault;
  }

  &__favorite {
    display: flex !important;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: min(1.6vw, 6px) 0;
    margin-top: 4px;
    font-size: min(2.67vw, 10px);

    i {
      display: block;
      width: min(3.73vw, 14px);
      height: min(3.73vw, 14px);
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    &__badge {
      width: 134px;
      min-width: 134px;
      margin: 0;
    }

    &__data {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      gap: 16px;
      width: 320px;
      text-align: left;

      p {
        width: 100%;
      }

      span {
        text-align: left;
      }
    }

    &__favorite {
      justify-content: flex-start;
    }
  }
}
</style>
